var resolve = {
  delay: function($q, $timeout, $rootScope, $location) {
	$rootScope.showAlerts = false;
	var delay = $q.defer();
	$timeout(delay.resolve, 0, false);
	return delay.promise;
  }
};

App.config(function($routeProvider, $locationProvider) {
  $routeProvider

	/* ------------------------ SIGNUP ----------------------- */
	.when('/register', {
		controller: 'DomainCtrl',
		templateUrl: '/js/app/views/signup/domain.html',
		resolve: resolve
	})
	.when('/register/userpass', {
      controller:'UserPassCtrl',
      templateUrl:'/js/app/views/signup/userpass.html',
      resolve: resolve
    })
    .when('/register/service', {
    	controller: 'CustomFieldsCtrl',
    	templateUrl: '/js/app/views/signup/fields.html',
    	resolve: resolve
    })
    .when('/register/contact', {
      controller:'ContactCtrl',
      templateUrl:'/js/app/views/signup/contact.html',
      resolve: resolve
    })
    .when('/register/email', {
      controller:'EmailCtrl',
      templateUrl:'/js/app/views/signup/email.php',
      resolve: resolve
    })
    .when('/register/cell', {
      controller:'CellCtrl',
      templateUrl:'/js/app/views/signup/cell.php',
      resolve: resolve
    })
    .when('/register/verify', {
      controller:'VerifyCtrl',
      templateUrl:'/js/app/views/signup/verify.html',
      resolve: resolve
    })
	.when('/register/starterpage', {
		controller:'StarterPageCtrl',
		templateUrl:'/js/app/views/signup/starterpage.html',
		resolve: resolve
	})
	.when('/register/payment', {
		controller:'PaymentCtrl',
		templateUrl:'/js/app/views/signup/payment.php',
		resolve: resolve
	})
	.when('/register/whois', {
		controller:'WhoisCtrl',
		templateUrl:'/js/app/views/signup/whois.php',
		resolve: resolve
	})
	.when('/register/complete', {
		controller:'CompleteCtrl',
		templateUrl:'/js/app/views/signup/alldone.html',
		resolve: resolve
	})
	.when('/', {
		controller: 'EmptyCtrl',
		template: " ",
		resolve: resolve
	})
	.when('/register/thankyou', {
		controller:'DomainCtrl',
		templateUrl:'/js/app/views/thankyou.html',
		resolve: resolve
	})
	
	/* ------------------------ LOGIN + DOMAINS + SERVICE REG. ----------------------- */
	.when('/modal', {
		controller: 'ModalCtrl',
		template: " ",
		resolve: resolve
	})
	.when('/modal/price', {
		controller: 'PricingCtrl',
		templateUrl: '/js/app/views/pricingmatrix.html',
		resolve: resolve
	})
	.when('/modal/login', {
		controller: 'LoginCtrl',
		templateUrl: '/js/app/views/login/login.html',
		resolve: resolve
	})
	.when('/modal/existing/domains', {
		controller: 'ExistingDomainsCtrl',
		templateUrl: '/js/app/views/domains/existing.html',
		resolve: resolve
	})
	.when('/modal/service', {
		controller: 'ServiceRegCtrl',
		templateUrl: '/js/app/views/service/servicereg.html',
		resolve: resolve
	})
	.when('/modal/updateuser', {
		controller: 'UpdateUserCtrl',
		templateUrl: '/js/app/views/login/updateuser.php',
		resolve: resolve
	})
	.when('/modal/percolator', {
		controller: 'PercolatorCtrl',
		templateUrl: '/js/app/views/login/percolator.html',
		resolve: resolve
	})

    .otherwise({
      redirectTo:'/'
    });
    
    // use the HTML5 History API
	//$locationProvider.html5Mode(true);
});
